/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import {
    object, func, string, arrayOf, number, shape,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { useUIDSeed } from 'react-uid';

const styles = (theme) => ({
    formControl: {
        [theme.breakpoints.down('sm')]: {
            minWidth: '100%',
        },
    },
    selectInput: {
        minWidth: 150,
    },
    selectOption: {
        width: 200,
        marginTop: 10,
        '& .MuiSelect-outlined': {
            padding: 8,
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    // Changing the property of Material UI Dropdown
    dropdownStyle: {
        top: '140px !important',
    },
    menuItemList: {
        fontSize: 16,
    },
});
const  OccasionSelect = ({
    classes, selectedOccasion, change, occasionData,
}) => {
    const handleChange = (event) => {
        change(event.target.value);
    };
    const seed = useUIDSeed();
    const sortedOccasions = occasionData.sort((occasionPrev, occasionNext) => {
        const occasion1 = Number(occasionPrev?.occasions?.rank || 0);
        const occasion2 = Number(occasionNext?.occasions?.rank || 0);
        let val = 0;
        if (occasion1 < occasion2) {
            val = -1;
        }
        if (occasion1 > occasion2) {
            val =  1;
        }
        if (occasion1 === 0 || occasion2 === 0) {
            val = 0;
        }
        return val;
    });
    const occasionItem = sortedOccasions?.map((data) => data?.occasions?.reference);
    return (occasionData?.length
        && (
            <div>
                <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel>Occasions</InputLabel>
                    <Select
                        value={selectedOccasion}
                        className={classes.selectOption}
                        onChange={(e) => handleChange(e)}
                        label="Occasion"
                        MenuProps={{
                            classes: { paper: classes.dropdownStyle },
                            variant: 'menu',
                        }}
                    >
                        <MenuItem value="default" className={classes.menuItemList} disabled>
                            Select a Occasion
                        </MenuItem>
                        {(occasionItem || []).map((occasion) => <MenuItem key={seed(occasion[0])} className={classes.menuItemList} value={occasion[0]?.uid}>{occasion[0].title}</MenuItem>)}
                    </Select>
                </FormControl>
            </div>
        )
    );
};
OccasionSelect.propTypes = {
    classes: object.isRequired,
    change: func.isRequired,
    selectedOccasion: string.isRequired,
    occasionData: arrayOf(
        shape({
            rank: number.isRequired,
            refrence: arrayOf(
                shape({
                    uid: string.isRequired,
                }),
            ).isRequired,
        }),
    ).isRequired,
};
export default withStyles(styles)(OccasionSelect);
